export const isElectronRuntime = () => {
  return typeof window !== 'undefined' && typeof window.ipcRenderer !== 'undefined';
};

export const isBrowserRuntime = () => !isElectronRuntime();

export const isHttpsBrowserRuntime = () => {
  return isBrowserRuntime()
    && typeof window !== 'undefined'
    && window.location?.protocol === 'https:';
};

export const supportsElectronDiscovery = () => {
  return isElectronRuntime()
    && typeof window.ipcRenderer?.send === 'function'
    && typeof window.ipcRenderer?.on === 'function';
};

export const supportsElectronFileWrites = () => {
  return isElectronRuntime()
    && typeof window.myJetpack?.file === 'function'
    && typeof window.myJetpack?.append === 'function'
    && typeof window.electronAPI?.joinPath === 'function';
};

export const supportsWebSerial = () => {
  return typeof navigator !== 'undefined'
    && typeof navigator.serial !== 'undefined'
    && (typeof window === 'undefined' || window.isSecureContext || isElectronRuntime());
};
